module.exports = __webpack_public_path__ + "img/50.1d6e64f9.jpg";